'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  font-weight: 700;
  font-size: 24px;
  width: 100%;
  color: ${theme.colors.primary[1]};
  text-align: center;
  @media screen and (width > ${theme.sizes.screens.md}) {
    font-size: 34px;
  }
`;
